import { useState } from "react";

export const useBucketController = (collapsible, initialCollapsed) => {
  const [collapse, setCollapse] = useState(collapsible && initialCollapsed);

  const toggleCollapse = () => {
    if (!collapsible) {
      return;
    }
    setCollapse((prev) => !prev);
  };

  return {
    collapse,
    toggleCollapse,
  };
};
